(() => {
  const rootSelector = '[data-mwt]';

  const setActive = (root, index) => {
    const tabs = root.querySelectorAll('[data-mwt-tab]');
    const panels = root.querySelectorAll('[data-mwt-panel]');

    tabs.forEach((tab, i) => {
      const active = i === index;
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      tab.tabIndex = active ? 0 : -1;
    });

    panels.forEach((panel, i) => {
      panel.toggleAttribute('hidden', i !== index);
    });
  };

  const init = (root) => {
    const tabs = root.querySelectorAll('[data-mwt-tab]');
    if (!tabs.length) return;

    setActive(root, 0);

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const index = Number(tab.dataset.mwtTab || 0);
        setActive(root, index);
      });

      tab.addEventListener('keydown', (e) => {
        const key = e.key;
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(key)) return;

        e.preventDefault();
        const current = Number(tab.dataset.mwtTab || 0);
        const max = tabs.length - 1;

        let next = current;
        if (key === 'ArrowLeft') next = Math.max(0, current - 1);
        if (key === 'ArrowRight') next = Math.min(max, current + 1);
        if (key === 'Home') next = 0;
        if (key === 'End') next = max;

        setActive(root, next);
        tabs[next].focus();
      });
    });
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll(rootSelector).forEach(init);
  };

  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();
